import {
  SHIPPING_SAME_DAY,
  SHIPPING_SAME_DAY_DELIVERY,
  SHIPPING_SHIPS_SAME_DAY
} from 'modules/shipping/constants'

const getShortDeliveryDateLabelShippingSelectorUtil = (props) => {
  const {
    isFastDeliveryAvailable,
    // isDeliveryAvailable,
    isDeliveryAvailabilityLoaded,
    isCompact
  } = props
  // logUtil('getShortDeliveryDateLabelShippingSelectorUtil').debug('props=', props)
  if (isDeliveryAvailabilityLoaded && isFastDeliveryAvailable && isCompact) {
    return SHIPPING_SAME_DAY
  }

  if (isDeliveryAvailabilityLoaded && isFastDeliveryAvailable) {
    return SHIPPING_SAME_DAY_DELIVERY
  }

  // if (isDeliveryAvailable) {
  return SHIPPING_SHIPS_SAME_DAY
  // }

  // return ''
}

export default getShortDeliveryDateLabelShippingSelectorUtil
